export default "__VITE_ASSET__1ac428af__"